import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "4eeadb62-5d68-4de6-bbcf-10aacbfef1a0",
    content: "Pure signal at one frequency",
    options: {},
  },
  {
    id: "36a202d2-2306-4ce6-a250-b3aa57c09f1c",
    content: "Dirac δ",
    options: {},
  },
  {
    id: "d3ef4778-51fc-4785-bd31-4e1beb19d274",
    content: "Rectangular window",
    options: {},
  },
  {
    id: "d0b1708f-6fa8-42a3-a11b-22edec342c5c",
    content: "None of them",
    options: {},
  },
];

export const task: Task = {
  id: "3dacf51f-9e1c-4f54-9954-ba5bf86a6bd7",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 4,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4eeadb62-5d68-4de6-bbcf-10aacbfef1a0"],
};
